export enum ECampaignStatus {
	DRAFT = 'draft',
	ACTIVE = 'active',
	SCHEDULED = 'scheduled',
	PAUSED = 'paused',
	COMPLETED = 'completed',
	ARCHIVED = 'archived',
}

export const CampaignStatusMap: Record<ECampaignStatus, string> = {
	[ECampaignStatus.DRAFT]: 'Szkic',
	[ECampaignStatus.ACTIVE]: 'Aktywny',
	[ECampaignStatus.SCHEDULED]: 'Zaplanowany',
	[ECampaignStatus.PAUSED]: 'Wstrzymany',
	[ECampaignStatus.COMPLETED]: 'Zakończony',
	[ECampaignStatus.ARCHIVED]: 'Archiwum',
}

export const CampaignStatusDotColor: Record<ECampaignStatus, string> = {
	[ECampaignStatus.DRAFT]: 'var(--color-green-700)',
	[ECampaignStatus.ACTIVE]: '#005c36',
	[ECampaignStatus.SCHEDULED]: 'var(--color-green-700)',
	[ECampaignStatus.PAUSED]: '#c18239',
	[ECampaignStatus.COMPLETED]: 'var(--color-on-background-light)',
	[ECampaignStatus.ARCHIVED]: '#8c2727',
}

// Mapowanie statusu kampanii na globalny komponent statusu <GlobalChipStatus> (EChipStatus),
// spójnie z listą kodów (CodeStatusChipType).
export const CampaignStatusChipType: Record<ECampaignStatus, EChipStatus> = {
	[ECampaignStatus.DRAFT]: EChipStatus.DRAFT,
	[ECampaignStatus.ACTIVE]: EChipStatus.ACTIVE,
	[ECampaignStatus.SCHEDULED]: EChipStatus.SCHEDULED,
	[ECampaignStatus.PAUSED]: EChipStatus.PAUSED,
	[ECampaignStatus.COMPLETED]: EChipStatus.COMPLETED,
	[ECampaignStatus.ARCHIVED]: EChipStatus.ARCHIVED,
}

export const CampaignStatuses = generateSelectOptions(ECampaignStatus, CampaignStatusMap)
export const CampaignFilterStatuses = CampaignStatuses.filter(s => s.value !== ECampaignStatus.SCHEDULED)

export const CAMPAIGN_STATUS_TRANSITIONS: Record<ECampaignStatus, ECampaignStatus[]> = {
	[ECampaignStatus.DRAFT]: [ECampaignStatus.ACTIVE, ECampaignStatus.ARCHIVED],
	[ECampaignStatus.ACTIVE]: [ECampaignStatus.PAUSED, ECampaignStatus.COMPLETED, ECampaignStatus.ARCHIVED],
	[ECampaignStatus.SCHEDULED]: [],
	[ECampaignStatus.PAUSED]: [ECampaignStatus.ACTIVE, ECampaignStatus.COMPLETED, ECampaignStatus.ARCHIVED],
	[ECampaignStatus.COMPLETED]: [ECampaignStatus.ARCHIVED],
	[ECampaignStatus.ARCHIVED]: [ECampaignStatus.DRAFT, ECampaignStatus.ACTIVE],
}

export enum ECampaignTab {
	LIST = 'list',
	ARCHIVE = 'archive',
}

export const CampaignDepartmentMap: Record<string, string> = {
	marketing: 'Marketing',
	sales: 'Sprzedaż',
	partner: 'Partner',
	biznes: 'Biznes',
}

export const CampaignDepartmentOptions = Object.entries(CampaignDepartmentMap).map(([value, label]) => ({
	value,
	label,
}))

export const CampaignChannelMap: Record<string, string> = {
	event: 'Event',
	influencer: 'Influencer',
	mailing: 'Mailing',
	pos: 'POS',
	www: 'WWW',
	partner: 'Partner',
}

export const CampaignChannelOptions = Object.entries(CampaignChannelMap).map(([value, label]) => ({ value, label }))
